var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-container" },
    [
      _c(
        "el-table",
        {
          attrs: {
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": "",
            "max-height": "500",
            data: _vm.promotions,
            "header-cell-class-name": "table-header-cell",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              width: "60",
              align: "center",
              type: "index",
              fixed: "left",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "限购", width: "60", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: "success",
                          effect: row.isLimited === 1 ? "dark" : "plain",
                        },
                      },
                      [_vm._v(_vm._s(row.isLimited === 1 ? "是" : "否"))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "限额数量",
              width: "80",
              align: "center",
              prop: "quota",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "活动数量",
              width: "80",
              align: "right",
              prop: "quantity",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "销量",
              width: "80",
              align: "right",
              prop: "volume",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "活动价",
              width: "80",
              align: "right",
              prop: "retailPrice",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "开始日期", align: "center", prop: "startDate" },
          }),
          _c("el-table-column", {
            attrs: { label: "结束日期", align: "center", prop: "endDate" },
          }),
          _c("el-table-column", {
            attrs: { label: "状态", width: "80", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      { attrs: { type: "success", effect: "dark" } },
                      [_vm._v(_vm._s(_vm.activityStatus[row.status]))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "80", align: "center", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-dropdown",
                      { attrs: { trigger: "click" } },
                      [
                        _c("span", { staticClass: "el-dropdown-link" }, [
                          _vm._v(" 操作"),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right",
                          }),
                        ]),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleEdit(
                                      scope.row,
                                      scope.$index
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-edit" }),
                                _vm._v(" 修改"),
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleDelete(
                                      scope.row,
                                      scope.$index
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-delete" }),
                                _vm._v(" 删除"),
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  divided: "",
                                  disabled: scope.row.status > 0,
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleStart(scope.row)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-check" }),
                                _vm._v(" 马上开始"),
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: { disabled: scope.row.status == 2 },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.handleFinish(scope.row)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-close" }),
                                _vm._v(" 结束活动"),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }